<template>
  <div>
    <!-- <b-form @submit="recaptcha"> -->
    <b-form>
      <b-form-group
        id="input-group-1"
        label="Email Address:"
        label-for="input-1"
        description="Your email will never be shared with anyone else.">
        <b-form-input
          id="input-1"
          v-model="form.sender_email"
          type="email"
          required
          placeholder="Enter email">
        </b-form-input>
      </b-form-group>

      <b-form-group id="input-group-2" label="Name:" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model="form.sender_name"
          required
          placeholder="Enter name">
        </b-form-input>
      </b-form-group>

      <b-form-group id="input-group-3" label="Email Subject:" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="form.email_subject"
          required>
        </b-form-input>
      </b-form-group>

      <b-form-group id="input-group-4">

      </b-form-group>

      <b-button variant="primary"
        @click="recaptcha">Submit</b-button>
      <!-- @click="recaptcha" -->
      <!-- <b-button class="g-recaptcha"
                data-sitekey="6LdcFvwUAAAAAM2jhLDpsaJJovp4cXMk9HK7UGZN"
                data-callback='onSubmit'
                data-action='submit'
                variant="primary">Submit</b-button> -->
                <!-- data-sitekey="process.env.GOOGLE_RECAPTCHA_SITE_KEY" -->
                <!-- @click="onSubmit($event)" -->
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        sender_email: '',
        sender_name: '',
        email_subject: '',
        email_body: ''
      }
    }
  },
  methods: {
    recaptcha() {
      // (optional) Wait until recaptcha has been loaded.
      // await this.$recaptchaLoaded()

      // Execute reCAPTCHA with action "login".
      // const token = await this.$recaptcha('submit')
      this.$recaptcha("submit").then(token => {
        console.log(token)
        let endpoint = 'https://6lpwy8trlj.execute-api.us-east-1.amazonaws.com/master-stage'
        let otherParams = {
          body: this.form,
          method: 'POST'
        }
        // Format this.form to JSON?
        fetch(endpoint, otherParams)
        // debugger
          .then(response => {
            console.log(response)
            // Flash message that the email sent
            // Clear the fields
          })
          .catch(error => {
            console.log(error)
          })
        // Do something with captcha expiration
        // Do I even need the package?
      })
    }

    // onSubmit(event) {
    //   console.log(event)
    //   // evt.preventDefault()
    //   // alert(JSON.stringify(this.form))
    // }
    // onSubmit(event) {
    //   console.log(event)
    //   // evt.preventDefault()
    //   // alert(JSON.stringify(this.form))
    // }
  }
}
</script>

<style>
  .grecaptcha-badge {
    /* visibility: hidden;  */
  }
</style>
